import styled from "styled-components";
import {StyledPopover} from "../../managers/reports/debt_list/debtList.styled";
import { colors } from "../ui/globalColors";

export const ActionsButtonStyled = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${colors.additionalColors.lightGray};
  border-radius: 50%;
  cursor: pointer;
  left: 3px;
  top: 10px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
  justify-content: center;
  box-shadow: -2px 3px 7px 0 ${colors.semiTransparentColors.gray};

  .dot {
    background-color: var(--bllink-purple);
    width: 3px;
    height: 3px;
    border-radius: 50px;
  }

  :hover {
    background: linear-gradient(180deg, ${colors.additionalColors.brightBlue} 0%, ${colors.additionalColors.purple} 100%);
    color: ${colors.textColors.white};

    .dot {
      background-color: ${colors.textColors.white};
    }
  }
`;

export const ActionListStyled = styled(StyledPopover)`
  button {
    display: block;
    width: 100%;
    border: none;
    background: transparent;
    text-align: start;
  } 
`
